import { useEffect } from "react";

import ContactSession from "./components/ContactSession";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <ContactSession />
    </div>
  );
};

export default Contact;
